<template>
    <div>
        <alert :type="alertType"
               :dismiss="3000"
               @dismissed="alert = false"
               v-if="alert"
               :show="alert">
            {{ this.alertMessage }}
        </alert>
        <form @submit.prevent @keyup.enter="doNothing" @keyup.enter.stop @keydown.enter.prevent="" class="u-mt--small survey wrapper" ref="form">
            <div class="surveyPage" v-for="page in getSurveyPages(filteredSurvey.surveyContent)" :key="page.hash">
                <div class="question" v-for="question in page" :key="question.id">
                    <template v-if="question.selectedQuestion.length != 0">
                        <div class="part" v-for="block in question.selectedQuestion[0].questionContent" :key="block.id">
                            <h2 v-if="block.__typename == 'questionContent_mainQuestion_BlockType'">{{ block.questionTitle }}</h2>
                            <label><input type="radio" @change="openSub($event)" :value="block.answer" :name="question.selectedQuestion[0].id" v-if="block.__typename == 'questionContent_answerRadio_BlockType'"> <span v-if="block.__typename == 'questionContent_answerRadio_BlockType'">{{block.answer}}</span></label>
                            <label><input type="text" @keyup.enter="doNothing" @click="openSub($event)" :name="block.id" v-if="block.__typename == 'questionContent_answerTextfield_BlockType'"></label>
                            <label><input type="checkbox" @change="openSub($event)" :name="block.id" :value="block.answer" v-if="block.__typename == 'questionContent_answerCheckbox_BlockType'"> <span v-if="block.__typename == 'questionContent_answerCheckbox_BlockType'">{{block.answer}}</span></label>
                            <template v-if="block.subQuestion != undefined">
                                <template v-if="block.subQuestion.length != 0">
                                    <div class="subquestion question" v-for="subquestion in block.subQuestion" :key="`s-${subquestion.id}`">
                                        <div v-for="subBlock in subquestion.questionContent" :key="`s-${subBlock.id}`" class="part">
                                            <h2 v-if="subBlock.__typename == 'questionContent_mainQuestion_BlockType'">{{ subBlock.questionTitle }}</h2>
                                            <label><input type="radio" :value="subBlock.answer" :name="block.id" v-if="subBlock.__typename == 'questionContent_answerRadio_BlockType'"> <span v-if="subBlock.__typename == 'questionContent_answerRadio_BlockType'">{{subBlock.answer}}</span></label>
                                            <label><input type="text" @keyup.enter="doNothing" :name="subBlock.id" v-if="subBlock.__typename == 'questionContent_answerTextfield_BlockType'"></label>
                                            <label><input type="checkbox" :name="subBlock.id" :value="subBlock.answer" v-if="subBlock.__typename == 'questionContent_answerCheckbox_BlockType'"> <span v-if="subBlock.__typename == 'questionContent_answerCheckbox_BlockType'">{{subBlock.answer}}</span></label>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                </div>
                <button class="button b-prev" @click="prevPage">Vorherige Seite</button>
                <button class="button b-next" @click="nextPage">Nächste Seite</button>
            </div>
            <div class="pageNumber">Seite <span class="c-page">1</span> von {{getPageNumber}}</div>
            <button class="button b-submit" @click="submit" @keyup.enter="doNothing">
                Absenden
                <i v-if="isSubmitting" class="fas fa-circle-notch fa-spin"></i>
                <i v-else class="fas fa-arrow-right"></i>
            </button>
        </form>
    </div>
</template>

<script>
import axios from "axios"
import alert from '../../Alert'

export default {
    components: {
        alert
    },
    props: ['lisaType','ssid'],
    data(){
        return {
            isSubmitting: false,
            alert: false,
            alertType: "success",
            alertMessage: "",
            surveyPage: 0,
            pages: 0
        }
    },
    methods: {
        openSub: function(event){
            let parent = event.target.parentElement.parentElement
            let ele = parent.parentElement.getElementsByClassName("subquestion")

            if(parent.getElementsByClassName("subquestion").length != 0){
                ele.forEach((e) => {
                    if(e.classList.contains("reveal")) {
                        e.classList.remove("reveal")
                        e.getElementsByTagName("input").forEach((el) => {
                            el.checked = false;
                        })
                    }
                })
                parent.getElementsByClassName("subquestion").forEach((e) => {
                    e.classList.add("reveal")
                })
            } else {
                if(ele.length != 0) {
                    ele.forEach((e) => {
                        if(e.classList.contains("reveal")) {
                            e.classList.remove("reveal")
                            e.getElementsByTagName("input").forEach((el) => {
                                el.checked = false;
                            })
                        }
                    })
                }
            }
        },
        getSurveyPages(questions){
          var pages = []
          var questionCount = 0
          var arrayCount = 0
          var subArray = []

          questions.forEach(function(e){
            if(questionCount == 6) {
              questionCount = 0
              pages[arrayCount] = subArray
              arrayCount++
              subArray = []
            }
            subArray[questionCount] = e
            questionCount++
          })
          pages[arrayCount] = subArray

          return pages;
        },
        doNothing: function(e) {
          e.preventDefault()
        },
        nextPage() {
          this.surveyPage++

          let page = this.surveyPage

          if(page == this.getPageNumber - 1) {
            this.$refs["form"].getElementsByClassName("b-submit")[0].style.display = "block"
          }

          this.$refs["form"].getElementsByClassName("surveyPage")[page-1].style.display = "none"
          this.$refs["form"].getElementsByClassName("surveyPage")[page].style.display = "block"
          this.$refs["form"].getElementsByClassName("c-page")[0].innerHTML = page + 1
          window.scrollTo(0,0);
        },
        prevPage() {
          this.surveyPage--

          let page = this.surveyPage

          this.$refs["form"].getElementsByClassName("surveyPage")[page+1].style.display = "none"
          this.$refs["form"].getElementsByClassName("surveyPage")[page].style.display = "block"
          this.$refs["form"].getElementsByClassName("b-submit")[0].style.display = "none"
          this.$refs["form"].getElementsByClassName("c-page")[0].innerHTML = page + 1
          window.scrollTo(0,0);
        },
        submit(){
            // Locking Mechanism
            if (!this.isSubmitting){
                let vm = this
                // Lock
                this.isSubmitting = true
                // Create empty data obj
                let data = {}
                data["fields"] = []

                // Append form fields to data obj
                for(let question of this.$refs["form"].getElementsByClassName("question")){
                    let values = []
                    for(let field of question.querySelectorAll(":scope > .part > label > input")) {
                        if(field.type == 'checkbox') {
                            if(field.checked){values.push(field.value)}
                        } else if(field.type == 'radio') {
                            if(field.checked){values.push(field.value)}
                        } else {
                            values.push(field.value)
                        }
                    }
                    if(question.querySelector("h2") != null){data["fields"].push({name: question.querySelector("h2").innerHTML,value: values})}
                }


                // Append static values to data obj
                data["action"] = "newSurvey"
                data["uid"] = this.ssid

                // Send Data
                axios({
                    method: "POST",
                    url: "https://pdf-degen.education-cloud.eu",
                    data: JSON.stringify(data)
                }).then((axiosResponse) => {
                  if(axiosResponse.status == 200 && axiosResponse.data.slice(-2) == "OK"){
                      this.alertType = "success"
                      this.alert = true
                      this.alertMessage = "Vielen Dank! Ihre Angaben wurden erfolgreich versendet."
                      vm.$emit("next")
                  } else if(axiosResponse.status == 200) {
                      this.alertType = "error"
                      this.alertMessage = "Es gab ein Problem beim versenden der Umfrage, bitte versuchen Sie es erneut."
                      this.alert = true
                  } else {
                      this.alertType = "error"
                      this.alertMessage = "Es gab ein Problem mit dem Server, bitte versuchen Sie es erneut"
                      this.alert = true
                  }
                    // Unlock
                    vm.isSubmitting = false
                })
            }
        }
    },
    computed: {
        surveys(){
            return this.$store.state.surveys.surveys
        },
        getPageNumber(){
          let pages = 0
          let survey = this.filteredSurvey.surveyContent

          pages = Math.trunc(survey.length / 6)
          if(survey.length % 6 != 0) {
            pages++
          }

          return pages
        },
        filteredSurvey(){
            let s = this.surveys
            let type = this.lisaType
            let returnValue = null

            if(type == undefined) {
                type = 'A'
            }

            s.forEach((e) => {
                if(e.surveytype.indexOf(type) != -1) {
                    returnValue = e
                }
            })
            return returnValue;
        }
    },
    updated() {
      let numberPages = this.$refs["form"].getElementsByClassName("surveyPage").length
      this.pages = numberPages
      for(let page of this.$refs["form"].getElementsByClassName("surveyPage")){
          page.style.display = "none"
      }
      this.pages = this.$refs["form"].getElementsByClassName("surveyPage")[0].style.display = "block"
      this.$refs["form"].getElementsByClassName("b-prev")[0].style.display = "none"
      this.$refs["form"].getElementsByClassName("b-next")[numberPages-1].style.display = "none"
      this.$refs["form"].getElementsByClassName("b-submit")[0].style.display = "none"
    },
    mounted() {
      let numberPages = this.$refs["form"].getElementsByClassName("surveyPage").length
      this.pages = numberPages
      for(let page of this.$refs["form"].getElementsByClassName("surveyPage")){
          page.style.display = "none"
      }
      this.pages = this.$refs["form"].getElementsByClassName("surveyPage")[0].style.display = "block"
      this.$refs["form"].getElementsByClassName("b-prev")[0].style.display = "none"
      this.$refs["form"].getElementsByClassName("b-next")[numberPages-1].style.display = "none"
      this.$refs["form"].getElementsByClassName("b-submit")[0].style.display = "none"
    }
};
</script>

<style scoped lang="scss">
    .question {
        margin: 60px 0;
    }

    .subquestion {
        margin: 20px 0 30px 40px;
        visibility: hidden;
        position:absolute;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s linear;
    }

    .reveal {
        position: static;
        visibility: visible;
        opacity: 1;
        transition: visibility 0s, opacity 0.5s linear;
    }
    button {margin-right: 10px}
    .pageNumber {
      margin-top: 20px;
    }
</style>
